import globalMessage from "@/utils/globalMessage";
import { useRequest } from 'ahooks';

import { api } from '@/redux/api';

export const useResetPassword = () => {
    const { loading, run: resetPassword } = useRequest(
        (email) => api.forgetpassword(email),
        {
            manual: true,
            onSuccess: () => {
                globalMessage.success({
                    message: 'Success',
                    description: "If an account matches this email, a password reset link will be sent. Check your inbox and spam folder.",
                    placement: 'topLeft'
                });
            },
            onError: (error) => {
                globalMessage.error({
                    message: 'Error',
                    description: error.message || 'Failed to reset password',
                    placement: 'topLeft'
                });
            }
        }
    );

    const handleResetPassword = (email) => {
        if (!email) {
            return globalMessage.error({
                message: 'Error',
                description: 'Please enter email',
                placement: 'topLeft'
            });
        }
        resetPassword(email);
    };

    return {
        loading,
        resetPassword: handleResetPassword
    };
}; 